import { Reducer } from "redux";

import {
	VendorComissionsActions,
	VendorComissionsActionTypes
} from "../../../actions/Vendor/Comissions";

export interface VendorComissionState {
	readonly isLoading: boolean;
	readonly editComissionsDrawerVisible: boolean;
}

export const initialVendorComissionState: VendorComissionState = {
	isLoading: false,
	editComissionsDrawerVisible: false
};

export const VendorPartnerReducer: Reducer<
	VendorComissionState,
	VendorComissionsActions
> = (
	state: VendorComissionState = initialVendorComissionState,
	action: VendorComissionsActions
): VendorComissionState => {
	switch (action.type) {
		case VendorComissionsActionTypes.SHOW_VENDOR_COMISSIONS_LOADER: {
			return {
				...state,
				isLoading: true
			};
		}
		case VendorComissionsActionTypes.HIDE_VENDOR_COMISSIONS_LOADER: {
			return {
				...state,
				isLoading: false
			};
		}
		case VendorComissionsActionTypes.OPEN_EDIT_VENDOR_COMISSIONS_DRAWER:
			return {
				...state,
				editComissionsDrawerVisible: true
			};
		case VendorComissionsActionTypes.CLOSE_EDIT_VENDOR_COMISSIONS_DRAWER:
			return {
				...state,
				editComissionsDrawerVisible: false
			};
		default: {
			return state;
		}
	}
};

export default VendorPartnerReducer;
